(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfCustomDataPdfDownloadFixedTableHeader', [
    '$window', '$rootScope', function($window, $rootScope) {
      return {
        link: (function(_this) {
          return function(scope, ele, attrs) {
            var calculatePixels, handleTableHeight;
            calculatePixels = function() {
              var child, children_height, container_height, fn, i, len, padding, ref;
              if (scope.hax === true) {
                padding = 120;
                children_height = 0;
                container_height = $('#sidebar-content')[0].clientHeight - padding;
                if (ele[0].children) {
                  ref = ele[0].children;
                  fn = function() {
                    if (child.className === 'forms-table-container ng-scope') {

                    } else {
                      return children_height += child.clientHeight;
                    }
                  };
                  for (i = 0, len = ref.length; i < len; i++) {
                    child = ref[i];
                    fn();
                  }
                  scope.available_pixels = container_height - children_height;
                  return handleTableHeight();
                }
              }
            };
            handleTableHeight = function() {
              var available, debug, form, total_width;
              scope.form_table_needed_pixels = 49 + (scope.rows.length * 29);
              debug = false;
              form = scope.form_table_needed_pixels;
              total_width = $('#row_head').width();
              available = scope.available_pixels;
              if (!scope.sized) {
                scope.form_table_style = {
                  'height': available
                };
                scope.width_style = {
                  'width': total_width / 2
                };
                scope.sized = true;
              }
              return $rootScope.$broadcast('resizer:loaded', {});
            };
            calculatePixels();
            return angular.element($window).bind('resize', debounce(function() {
              return calculatePixels();
            }));
          };
        })(this)
      };
    }
  ]);

}).call(this);
